import React, { FunctionComponent } from "react";
import styles from "./Entrance.module.scss";
import EntranceContent from "./EntranceContent.model";

import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import formatDynamicTextBreak from "blocks/helpers/formatDynamicTextBreak";

const Entrance: FunctionComponent<EntranceContent> = (props) => {
    const lengthClass = props.length && props.length > 1 ? styles.has_multiple : styles.has_single;

    const media = props?.media;
    const imageCrop = getImageCrop(media?.crops, undefined, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, media?.width, media?.height);

    const link = props?.links && props?.links.length > 0 ? props?.links[0].link : undefined;
    const processedTagline = getProcessedRichtext(formatDynamicTextBreak(props?.tagline));
    const processedHeadline = getProcessedRichtext(formatDynamicTextBreak(props?.headline));

    const backgroundColorValue = props?.backgroundColor?.color;
    const bgColor = backgroundColorValue ? (backgroundColorValue.startsWith("#") ? backgroundColorValue : `#${backgroundColorValue}`) : undefined;

    const textColorValue = props?.textColor?.color;
    const textColor = textColorValue ? (textColorValue.startsWith("#") ? textColorValue : `#${textColorValue}`) : undefined;

    return (
        <div
            className={combineClasses([styles.wrapper, props.className])}
            style={{ "--background-color": bgColor } as React.CSSProperties}
        >
            <Anchor
                className={combineClasses([styles.link, lengthClass])}
                to={link}
            >
                <div className={styles.content}>
                    {/* Tagline */}
                    <span
                        className={styles.tagline}
                        style={{ color: textColor }}
                        dangerouslySetInnerHTML={processedTagline}
                    ></span>

                    {/* Headline */}
                    <h3
                        className={styles.headline}
                        style={{ color: textColor }}
                        dangerouslySetInnerHTML={processedHeadline}
                    ></h3>
                </div>

                {/* Media */}
                <div className={styles.media}>
                    {media !== null ? (
                        <ImageViewer
                            className={styles.image}
                            src={media?.url || media}
                            crop={imageCrop}
                            focalPoint={media?.focalPoint}
                            {...imageAspectRatio}
                            alt={""}
                        />
                    ) : null}
                </div>
            </Anchor>
        </div>
    );
};

export default Entrance;
